import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './FAQOverview';

const FAQOverviewSuspense = dynamic(() => import('./FAQOverview'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicFAQOverview(props: Props) {
	return <FAQOverviewSuspense {...props} />;
}
DynamicFAQOverview.displayName = 'DynamicFAQOverview';
